<template>
  <ol class="breadcrumb page-breadcrumb">
    <li
      v-for="(item, index) in breadcrumbRouterItems"
      :key="'breadCrumb' + index"
      class="breadcrumb-item"
      :class="{ active: index === breadcrumbRouterItems.length - 1 }"
    >
      <i class="fal fa-fw" v-if="item.icon" :class="item.icon" />

      <router-link
        v-if="item.name && index !== breadcrumbRouterItems.length - 1"
        :to="{ name: item.name }"
      >
        {{
        toI18n(item.title)
        }}
      </router-link>

      <span v-else>{{ toI18n(item.title) }}</span>
    </li>
  </ol>
</template>

<script>
import { mapState } from 'vuex';

import { getMenuElements, getBreadcrumbItems } from '@/utils';

export default {
  computed: {
    ...mapState({
      appTitle: state => state.system.appTitle
    }),
    breadcrumbRouterItems() {
      const parentRoute = getMenuElements(this.$router.options.routes);
      const route = getBreadcrumbItems(parentRoute).find(x => x.route.name === this.$route.name);
      if (!route) {
        return undefined;
      }
      const home = { icon: 'fa-home', title: 'Start', name: 'home' };
      const parents = route.parents ? route.parents.map(parent => parent.route) : [];
      const crumbs = [home, ...parents, route.route].filter(item => item.title);
      const lastCrumb = crumbs[crumbs.length - 1];
      if (lastCrumb) {
        document.title = this.toI18n(lastCrumb.title) + ' - ' + this.appTitle;
        return crumbs;
      } else {
        document.title = this.appTitle;
      }
    }
  },
  methods: {
    toI18n(value) {
      return value.startsWith('breadcrumbs.') ? this.$t(value) : value;
    }
  }
};
</script>

<style>
.breadcrumb > li.breadcrumb-item {
  max-width: 200px;
}
.breadcrumb > li.breadcrumb-item:last-of-type span {
  font-weight: 400 !important;
  color: #1d2d3a;
}
.breadcrumb > li.breadcrumb-item:first-of-type i {
  width: 1.45rem;
  text-align: left;
  color: #1d2d3a;
}
</style>